export default "__VITE_ASSET__Bmb4Ao8F__"